import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:8000';

// Store active request controller for cancellation
let activeController = null;

/**
 * Open Poke Agent Service
 * Provides an interface to the backend agent logic.
 */
export const openPokeAgent = {
  /**
   * Handle a message using the backend agent.
   *
   * @param {string} message - The user's message.
   * @param {object} userProfile - The user's profile data.
   * @param {Array} history - The chat history (optional).
   * @returns {Promise<string>} - The agent's reply.
   */
  handle: async (message, userProfile, history = []) => {
    // Cancel any previous pending request
    if (activeController) {
      activeController.abort();
    }

    // Create new AbortController for this request
    activeController = new AbortController();

    try {
      // Strip ad messages — backend only understands 'user' and 'agent' roles
      const filteredHistory = history.filter(m => m.role === 'user' || m.role === 'agent');

      const response = await axios.post(`${BACKEND_URL}/api/open-poke/handle`, {
        message,
        user_profile: userProfile,
        history: filteredHistory
      }, {
        signal: activeController.signal,
        timeout: 45000 // 45 second timeout
      });

      activeController = null; // Clear on success

      if (response.data && response.data.reply) {
        return response.data.reply;
      }

      throw new Error('Invalid response from agent');
    } catch (error) {
      activeController = null; // Clear on error

      // Don't log aborted requests as errors
      if (axios.isCancel(error)) {
        throw new Error('Request cancelled');
      }

      console.error('Error calling Open Poke Agent:', error);
      throw error;
    }
  },

  /**
   * Cancel any pending request
   */
  cancel: () => {
    if (activeController) {
      activeController.abort();
      activeController = null;
    }
  }
};
